import FormField from './form_field';
import AutocompleteFormField from './autocomplete_form_field';
import RadioFormField from './radio_form_field';
import CheckboxFormField from './checkbox_form_field';
import DatepickerFormField from './datepicker_form_field';
import DocumentFormField from './document_form_field';
import GridFormField from './grid_form_field';
import LabelFormField from './label_form_field';

export const create = (formFieldProps) => {
	const formFieldClass = getModelClass(formFieldProps.component);
	return new formFieldClass(formFieldProps);
};

export const getModelClass = (formFieldComponent) => {
	switch(formFieldComponent) {
		case 'autocomplete':
			return AutocompleteFormField;
		case 'datepicker':
			return DatepickerFormField;
		case 'document':
			return DocumentFormField;
		case 'gridform':
			return GridFormField;
		case 'radio':
			return RadioFormField;
		case 'checkbox':
			return CheckboxFormField;
		case 'label':
			return LabelFormField;
		default:
			return FormField;
	}
};

export default {
	create,
	getModelClass,
};
